<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-07-28 10:53:16
 * @LastEditTime: 2021-11-19 18:37:30
 * @Description:
-->

<template>
    <div class="jdmall-portal-header">
        <div class="logo">
            <div class="logo-icon"></div>
            <!-- <div class="logo-text">超星系统</div> -->
        </div>
        <topMenu> </topMenu>
        <div
            @click="clickLogOut"
            class="user"
            v-click-outside="
                (e) => {
                    showLogOut = false
                }
            "
        >
            <div class="user-icon"></div>
            <div class="user-name">{{ fullName }}({{ jdErp }})</div>
            <div class="user-arrow"></div>

            <div v-if="showLogOut" class="login-lout">
                <div @click="confirmLogOut" class="login-lout-icon"></div>
                <div @click="confirmLogOut" class="login-lout-text">
                    退出登陆
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { directive as clickOutside } from 'v-click-outside-x'
import { LOGIN_URL, TENANT_URL } from '../utils/constants'
import { queryUser } from '@/api/menu'
import topMenu from './topMenu'

export default {
    name: 'portalHeader',
    directives: { clickOutside },
    components: {
        topMenu,
    },
    props: {
        userName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showLogOut: false,
            fullName: '',
            jdErp: '',
        }
    },
    created() {
        queryUser({ resourceType: 1 }).then((res) => {
            if (res && res.data) {
                this.fullName = res.data.fullName
                this.jdErp = res.data.erp
                window.sessionStorage.setItem(
                    'userInfo',
                    JSON.stringify(res.data)
                )
            } else {
                window.sessionStorage.setItem('userInfo', JSON.stringify({}))
            }
        })
    },
    methods: {
        clickLogOut() {
            this.showLogOut = true
        },
        confirmLogOut() {
            window.location.href = `${TENANT_URL}/jd/logOut?ReturnUrl=${LOGIN_URL}`
        },
    },
    watch: {},
}
</script>

<style lang="scss" scoped>
.jdmall-portal-header {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    min-width: 1280px;
    height: 48px;
    background: #fc3d3b;
    z-index: 99;
    .logo {
        width: 168px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &-icon {
            width: 122px;
            height: 24px;
            background: url('../assets/logo.svg') center no-repeat;
        }
        &-text {
            margin-left: 4px;
            font-size: 26px;
            font-family: 'JDLANGZHENG';
            color: rgba(255, 255, 255, 1);
        }
    }
    .user {
        position: relative;
        margin-right: 32px;
        display: flex;
        align-items: center;
        &-icon {
            width: 32px;
            height: 32px;
            background: url('../assets/user-icon.svg') center no-repeat;
        }
        &-name {
            margin-left: 5px;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 500;
            color: #fff;
        }
        &-arrow {
            margin-left: 8px;
            width: 12px;
            height: 6px;
            background: url('../assets/arrow.svg') center no-repeat;
        }
    }

    .login-lout {
        position: absolute;
        left: 0;
        right: 0;
        top: 52px;
        display: flex;
        align-items: center;
        height: 52px;
        border-radius: 8px;
        box-shadow: 2px 2px 18px 0 rgba(26, 26, 26, 0.08);
        background: #fff;
        &-icon {
            margin-left: 18px;
            width: 20px;
            height: 20px;
            background: url('../assets/logout.svg') center no-repeat;
            cursor: pointer;
        }
        &-text {
            margin-left: 8px;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
        }
    }
}
</style>
